import {
  BatteryManufacturer,
  EVSEManufacturer,
  VehicleManufacturer,
  type Manufacturer,
} from "../../state/api.types";
import { enumLookup } from "../../utilities/enum";

export type { Manufacturer };

export const manufacturerDisplayNames = {
  [BatteryManufacturer.Tesla]: "Tesla",
  [BatteryManufacturer.SolarEdge]: "SolarEdge",
  [BatteryManufacturer.Enphase]: "Enphase",
  [BatteryManufacturer.Sigenergy]: "Sigenergy",
  [BatteryManufacturer.Franklin]: "Franklin",
  [BatteryManufacturer.EcoFlow]: "EcoFlow",
  [BatteryManufacturer.Duracell]: "Duracell",
  [BatteryManufacturer.FoxESS]: "FoxESS",
  [BatteryManufacturer.Sonnen]: "Sonnen",
  [BatteryManufacturer.Generac]: "Generac",
  [BatteryManufacturer.EPCube]: "EP Cube",
  [EVSEManufacturer.Emporia]: "Emporia",
  [VehicleManufacturer.Hyundai]: "Hyundai",
  [VehicleManufacturer.Volvo]: "Volvo",
  [VehicleManufacturer.Rivian]: "Rivian",
  [VehicleManufacturer.Genesis]: "Genesis",
} as const satisfies Record<Manufacturer, string>;

export function getManufacturerDisplayName(manufacturer: string): string {
  return enumLookup(manufacturerDisplayNames, manufacturer) ?? manufacturer;
}
